import {Price} from '~/gql/graphql'

// I know it's hacky
export const getPriceFromPriceString = (formattedPrice: string): Price => {
    const price = formattedPrice.match(/([0-9]+[,.][0-9]+)/)?.[1]
    const commaPrice = String(price).replace('.', ',')
    const dotPrice = String(price).replace(',', '.')
    const symbol = formattedPrice.replace(commaPrice, '').replace(dotPrice, '').trim()
    const pattern = formattedPrice
        .replace(commaPrice, '%')
        .replace(dotPrice, '%')
        .replace(symbol, '$')

    return {
        vatExcluded: Number(dotPrice),
        vatIncluded: Number(dotPrice),
        vatAmount: 0,
        currency: {
            pattern: pattern,
            symbol: symbol,
        },
    }
}
